import { useQuery } from "@apollo/client";
import { useCallback } from "react";
import { useMemo } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom"
import { setBroker } from "src/actions";
import { COOKIES } from "src/context/constants";
import { BROKERS } from "src/graphql/queries/brokers";
import useCookie from "src/hooks/useCookie";
import authService from "src/services/authService";
// import authService from "src/services/authService"
import { brokersQuery, brokerType } from "src/types/broker-types";

interface getModelInfoUrlType {
  modelID:string
  modelName:string
}

interface mapperBrokerNameToIDType {
  [brokerName:string] : brokerType
}


const useRouteManager = () => {

  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const { data:Brokers } = useQuery<brokersQuery>(BROKERS)
  const { setCookie } = useCookie()

  const brokers = useMemo(()=>{
    if (Brokers?.brokers.__typename === "Brokers") 
      return Brokers.brokers.brokers.filter(broker => broker.name !== 'bitkub')
    return []
  },[Brokers])

  const brokerNameOnURL = useMemo(()=>{
    let bkr = getBrokerNameFromPathname(location.pathname)
    return bkr
  },[location])

 

  const [mapperBrokernameToBroker,brokerList] = useMemo(()=>{
    const mapper:mapperBrokerNameToIDType = {}
    const brokerList:Array<string> = []
    for (let i=0;i<brokers.length;i++) {
      let bkr = brokers[i]
      mapper[bkr.name.toLowerCase()] = bkr
      brokerList.push(bkr.name)
    }
    return [mapper,brokerList]
  },[brokers])

  const brokerID = useMemo(() => {
    if(mapperBrokernameToBroker && brokerNameOnURL) {
      return mapperBrokernameToBroker[brokerNameOnURL]
    } 
  },[mapperBrokernameToBroker, brokerNameOnURL])

  const saveBroker = useCallback(async(broker:string)=>{
    if (!broker) return
    if (typeof broker === "string") {
      let brokerParsing:brokerType = {
        brokerID:mapperBrokernameToBroker[broker].brokerID,
        name:broker,
        exchange:mapperBrokernameToBroker[broker].exchange
      }
      setCookie(COOKIES.latestSelBroker,broker,14,false)
      dispatch(setBroker(brokerParsing))
    }
  },[mapperBrokernameToBroker,dispatch,setCookie])

  async function silenceSwitchBroker(fromBrokerName:string,toBrokerName:string) {
    const fromBrokerID = mapperBrokernameToBroker[fromBrokerName.toLowerCase()].brokerID
    const toBrokerID = mapperBrokernameToBroker[toBrokerName.toLowerCase()].brokerID
    await authService.switchBroker(fromBrokerID,toBrokerID)
  }


  async function switchBroker(toBrokerName:string) {
    try {
      // const mapper = mapperBrokernameToID
      // const currentBrokerName = getBrokerName()
      // const fromBrokerID = mapper[currentBrokerName.toLowerCase()]
      // const toBrokerID = mapper[toBrokerName.toLowerCase()]
      toBrokerName = toBrokerName.toLowerCase()

      let path = window.location.pathname
      let path_l = path.split("/")
      path_l[1] = toBrokerName
      var index = path_l.indexOf('guest');
      if (index !== -1) {
        path_l.splice(index, 1);
      }
      let newPath = path_l.join("/")

      // await authService.switchBroker(fromBrokerID,toBrokerID)

      // setCookie(COOKIES.latestSelBroker,toBrokerName,3,false)
      // saveBroker(toBrokerName)
      
      window.location.pathname = newPath
    } catch(_) {
      window.location.reload()
    }
  }

  function getBrokerName() {
    let path = window.location.pathname
    let path_l = path.split("/")
    if (path_l.length < 1) return ""
    return path_l[1]
  }

  function getBrokerNameFromPathname(pathname:string) {
    let path_l = pathname.split("/")
    if (path_l.length < 1) return ""
    return path_l[1]
  }

  function getModelInfoPathname(props:getModelInfoUrlType) {
    const brokerName = getBrokerName()
    const modelPath = `/model?name=${props.modelName}&id=${props.modelID}`
    return "/"+brokerName+modelPath
  }

  function getRedirectPathname(redirectTo:string) {
    const brokerName = getBrokerName()
    return "/"+brokerName+redirectTo
  }

  function redirect(to:string) {
    const path = getRedirectPathname(to)
    history.push(path)
  }

  const hook = {
    switchBroker,
    silenceSwitchBroker,
    redirect,
    brokerNameOnURL,
    mapperBrokernameToBroker,
    brokerList,
    saveBroker,
    getBrokerName,
    getModelInfoPathname,
    getRedirectPathname,
    brokerID,
  }

  return hook

}

export default useRouteManager